<template>
  <div class="bg-gray-800 py-2 rounded-t-none rounded-lg">
    <div class="px-3 py-2">Taille d'affichage</div>
    <div class="flex justify-between px-4 pt-2 pb-4">
      <div
        @click="handleSetItemsPerLine(9)"
        class="flex flex-col items-center cursor-pointer"
      >
        <div class="flex items-center h-8">
          <div class="w-4 h-4 rounded" :class="[itemsPerLine === 9 ? 'bg-white' : 'bg-gray-600']"></div>
        </div>
        <div :class="[itemsPerLine === 9 ? 'text-white' : 'text-gray-600']">
          Petit
        </div>
      </div>
      <div
        @click="handleSetItemsPerLine(7)"
        class="flex flex-col items-center cursor-pointer"
      >
        <div class="flex items-center h-8">
          <div class="w-5 h-5 rounded" :class="[itemsPerLine === 7 ? 'bg-white' : 'bg-gray-600']"></div>
        </div>
        <div :class="[itemsPerLine === 7 ? 'text-white' : 'text-gray-600']">Moyen</div>
      </div>
      <div
        @click="handleSetItemsPerLine(5)"
        class="flex flex-col items-center cursor-pointer"
      >
        <div class="flex items-center h-8">
          <div class="w-6 h-6 rounded" :class="[itemsPerLine === 5 ? 'bg-white' : 'bg-gray-600']"></div>
        </div>
        <div :class="[itemsPerLine === 5 ? 'text-white' : 'text-gray-600']">Grand</div>
      </div>
    </div>
    <div v-if="errorMaxItems > 0" class="text-center font-light bg-red-500 text-white w-full py-3 focus:outline-none">
      {{ errorMaxItems }} labels max
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex"

export default {
  data() {
    return {
      errorMaxItems: 0,
    }
  },
  computed: {
    ...mapState({
      itemsPerLine: state => state.grid.itemsPerLine,
      selectedLabels: (state) => state.labels.selected,
    })
  },
  methods: {
    ...mapActions({
      setItemsPerLine: "grid/setItemsPerLine"
    }),
    handleSetItemsPerLine(itemsCount) {
      if (this.selectedLabels.length > itemsCount - 1) {
        this.errorMaxItems = itemsCount - 1
        return
      }
      this.errorMaxItems = 0
      this.setItemsPerLine(itemsCount)
      this.$emit("closeMenu")
    }
  }
}
</script>

<style></style>
